export const MAX_BATCH_ORS_SMARTLINKS = 50;
export const DEFAULT_ORS_TIMEOUT = 700;
